






















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Types
import { IClient } from "@/models/clients";

@Component
export default class BaseRuleDayOfMonthField extends Vue {
  // Props

  @Prop({ required: true })
  public value!: IClient["invoice_consolidation_base_rule_date_of_month_day"];

  @Prop({ required: true })
  public brandValue!: IClient["invoice_consolidation_base_rule_date_of_month_day"];

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public dayOfMonthValue: IClient["invoice_consolidation_base_rule_date_of_month_day"] = null;
  public sliderKey = "";
  public initiating = true;

  // Methods

  public created() {
    this.dayOfMonthValue = _.isNull(this.value) ? this.brandValue : this.value;
    this.$nextTick(() => {
      this.initiating = false;
    });
  }

  public dayOrdinalNumber(value) {
    return this.$moment(`01-${value}`, "MM-DD").format("Do");
  }

  public restoreDefault() {
    this.$set(this, "dayOfMonthValue", this.brandValue);
    this.setSliderKey();

    this.$nextTick(() => {
      this.$emit("input", null);
    });
  }

  public changeValue(value) {
    if (!this.initiating) {
      this.$emit("input", value);
    }
  }

  public setSliderKey() {
    this.$set(this, "sliderKey", this.$uuid());
  }

  // Computed

  public get showRestoreButon() {
    return !_.isNull(this.value);
  }

  // Watchers

  @Watch("value")
  public onValueChange() {
    if (!_.isNull(this.value)) return;

    this.initiating = true;

    this.$set(this, "dayOfMonthValue", this.brandValue);
    this.setSliderKey();

    this.$nextTick(() => {
      this.initiating = false;
    });
  }
}
